/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_7_DescInputs */

const en_mk_feature_7_desc = /** @type {(inputs: Mk_Feature_7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Rooms, capstone projects, participation, and rubrics support collaborative learning.`)
};

const id_mk_feature_7_desc = /** @type {(inputs: Mk_Feature_7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room, proyek capstone, partisipasi tim, dan rubrik membantu proses belajar bersama.`)
};

/**
* | output |
* | --- |
* | "Design Rooms, capstone projects, participation, and rubrics support collaborative learning." |
*
* @param {Mk_Feature_7_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_7_desc = /** @type {((inputs?: Mk_Feature_7_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_7_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_7_desc(inputs)
	return en_mk_feature_7_desc(inputs)
});